/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-underscore-dangle */
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setBidDetails } from 'actions/bidDetailAction';
import FSBModal from 'components/common/FSBModal';
import BiddingOfferDetails from 'components/BiddingOfferDetails';
import BiddingDemandDetails from 'components/BiddingDemandDetails';

const BiddingDetailsDrawer = () => {
  const dispatch = useDispatch();
  const { status, selectedBid } = useSelector(
    (state) => state.bidDetailsReducer,
  );
  const drawerToggle = () => {
    dispatch(setBidDetails({ status: false, selectedBid: null }));
  };

  useEffect(() => {
    dispatch(setBidDetails({ status: false, selectedBid: null }));
  }, []);

  window.addEventListener('popstate', () => {
    drawerToggle();
  });

  return (
    <>
      {' '}
      {status && (
        <FSBModal
          open={status}
          size="xl"
          title={
            selectedBid?.bidType === 'offer'
              ? 'Offer Details'
              : 'Demand Details'
          }
          closeButtonLabel=""
          confirmButtonLabel=""
          message=""
          toggleAlert={drawerToggle}
          onClose={drawerToggle}
          onConfirmClick={drawerToggle}
          modalClass="right-drawer right-drawer-details bidding-details-drawer"
        >
          {selectedBid?.bidType === 'offer' && (
            <BiddingOfferDetails
              id={selectedBid?.id}
              bidType={selectedBid?.bidType}
              bidOfferType={selectedBid?.bidOfferType}
            />
          )}
          {selectedBid?.bidType === 'demand' && (
            <BiddingDemandDetails
              id={selectedBid?.id}
              bidType={selectedBid?.bidType}
              bidDemandType={selectedBid?.bidDemandType}
            />
          )}
        </FSBModal>
      )}
    </>
  );
};

export default BiddingDetailsDrawer;
